module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.pages), function(page, i) {
    return _c('Page', {
      key: i,
      class: {
        'Page--continuing': i < _vm.pages.length - 1 && !page.table
      }
    }, [(i === 0) ? _c('div', {
      staticClass: "Proposal-Info"
    }, [_c('span', {
      staticClass: "Proposal-Info--Number"
    }, [_vm._v(_vm._s(_vm.proposal['Type']) + " Nr. " + _vm._s(_vm.proposal['Project-Number']))]), _vm._v(" "), _c('span', {
      staticClass: "Proposal-Info--Date"
    }, [_vm._v("vom " + _vm._s(_vm.proposal['Date']))])]) : _vm._e(), _vm._v(" "), (page.phases && page.phases.length) ? _c('div', {
      staticClass: "Milestones",
      class: {
        'Milestones--noTime': _vm.proposal.milestones['Time'] == 0
      }
    }, [(i === 0) ? _c('div', {
      staticClass: "Header"
    }, [_c('span', [_vm._v("Leistungen/ Phase")]), _vm._v(" "), _c('span', [_vm._v("Kosten")]), _vm._v(" "), (_vm.proposal.milestones && _vm.proposal.milestones['Time'] !== 0) ? _c('span', [_vm._v("Zeitraum")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
      ref: "milestonesTree",
      refInFor: true,
      staticClass: "Milestones-Tree"
    }, _vm._l((page.phases), function(milestone, i) {
      return _c('Phase', {
        key: i,
        class: {
          'Phase--noName': milestone.fromPrev
        },
        attrs: {
          "itemValues": milestone.values,
          "milestones": _vm.proposal.milestones
        }
      }, _vm._l((milestone.children), function(firstLayer) {
        return _c('FirstLayer', {
          key: firstLayer.id,
          attrs: {
            "itemValues": firstLayer.values
          }
        }, _vm._l((firstLayer.children), function(secondLayer) {
          return _c('SecondLayer', {
            key: secondLayer.id,
            attrs: {
              "itemValues": secondLayer.values
            }
          }, _vm._l((secondLayer.children), function(thirdLayer) {
            return _c('ThirdLayer', {
              key: thirdLayer.id,
              attrs: {
                "itemValues": thirdLayer.values
              }
            })
          }), 1)
        }), 1)
      }), 1)
    }), 1)]) : _vm._e(), _vm._v(" "), (page.table && page.phases && page.phases.length) ? _c('PriceTable', {
      attrs: {
        "milestones": _vm.proposal.milestones
      }
    }) : _vm._e(), _vm._v(" "), (page.optionalPhases && page.optionalPhases.length) ? _c('div', {
      staticClass: "Milestones Milestones--optional",
      class: {
        'Milestones--noTime': !_vm.proposal.milestones['Time-Optional']
      }
    }, [(i === _vm.optionalPageNum) ? _c('div', {
      staticClass: "Proposal-Info"
    }, [_c('span', {
      staticClass: "Proposal-Info--Number"
    }, [_vm._v("Optionale Posten")])]) : _vm._e(), _vm._v(" "), _c('ul', {
      ref: "milestonesTree",
      refInFor: true,
      staticClass: "Milestones-Tree"
    }, _vm._l((page.optionalPhases), function(milestone, i) {
      return _c('Phase', {
        key: i,
        class: {
          'Phase--noName': milestone.fromPrev
        },
        attrs: {
          "itemValues": milestone.values,
          "milestones": _vm.proposal.milestones
        }
      }, _vm._l((milestone.children), function(firstLayer) {
        return _c('FirstLayer', {
          key: firstLayer.id,
          attrs: {
            "itemValues": firstLayer.values
          }
        }, _vm._l((firstLayer.children), function(secondLayer) {
          return _c('SecondLayer', {
            key: secondLayer.id,
            attrs: {
              "itemValues": secondLayer.values
            }
          }, _vm._l((secondLayer.children), function(thirdLayer) {
            return _c('ThirdLayer', {
              key: thirdLayer.id,
              attrs: {
                "itemValues": thirdLayer.values
              }
            })
          }), 1)
        }), 1)
      }), 1)
    }), 1)]) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d66f0282","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Milestones.vue
// module id = 170
// module chunks = 4